import { gearsLoader } from "@made-people/gears-remix";
import {
  withGlobalStory,
  WithGlobalStoryProps,
} from "../../utils/with-global-story";
import { getStoryFromGlobalStoryblokStoriesBySlug } from "../../utils/global-story-functions";
import { FooterProps } from "@made-people/blueprint-footer";
import { useRouteLoaderData } from "@remix-run/react";
import { SbBlokData } from "@storyblok/js";
import { NewsletterSignupProps } from "@made-people/blueprint-newsletter-signup";

const Component = withGlobalStory(
  {
    lookupType: "slug",
    slug: "shared-content/footer/global-footer",
  },
  (story) =>
    ({
      ...story,
      template: "template2",
    }) satisfies FooterProps,
);

export const Footer = (props: WithGlobalStoryProps) => {
  const loaderData = useRouteLoaderData<typeof gearsLoader>(
    "project-router-wildcard",
  );

  if (!loaderData) return null;

  const {
    pageResponse: { page },
  } = loaderData;

  const isCheckout =
    page.pageType === "checkoutFinalize" ||
    page.pageType === "checkoutReceipt" ||
    page.pageType === "checkoutIndex";

  if (isCheckout) return null;

  // Storyblok partner-logos structure: { logos: [{ logos: SbBlokData[] }] }
  const partnerLogosStory = getStoryFromGlobalStoryblokStoriesBySlug(
    "shared-content/partner-logos/partner-logos",
    props.globalStoryblokStories,
  ) as { logos?: Array<{ logos?: SbBlokData[] }> } | undefined;

  const logos = partnerLogosStory?.logos?.[0]?.logos ?? [];

  const newsletterConfig: NewsletterSignupProps = {
    template: "template4",
    heading: {
      heading: "Newsletter_Signup_Heading",
    },
    form: {
      inputField: {
        placeholder: "Newsletter_Email_Placeholder",
      },
      phoneNumberField: {
        placeholder: "Newsletter_PhoneNumber_Placeholder",
      },
      submitButton: {
        buttonLabel: "Newsletter_Subscribe_Button",
      },
      subscribeAttributes: {
        optinMethod: "footer",
      },
    },
  };

  return (
    <Component
      {...props}
      additionalProps={{
        newsletter: {
          isEnabled: true,
          settings: newsletterConfig,
        },
        partnerLogos: {
          template: "template1",
          logos,
        },
      }}
    />
  );
};
